import type { User } from '@/api/common/auth';
import { create } from 'zustand';

interface AuthState {
  // Clerk auth state
  isLoaded: boolean | undefined;
  isSignedIn: boolean | undefined;

  // User data from whoAmI (optional decoration)
  user: User | null;
  isLoadingUserData: boolean;

  // Actions
  setClerkAuth: (isLoaded: boolean | undefined, isSignedIn: boolean | undefined) => void;
  setUser: (user: User | null) => void;
  setLoadingUserData: (loading: boolean) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  // Clerk state
  isLoaded: false,
  isSignedIn: false,

  // User data
  user: null,
  isLoadingUserData: false,

  setClerkAuth: (isLoaded, isSignedIn) => {
    set({ isLoaded, isSignedIn });
  },

  setUser: (user) => {
    set({ user, isLoadingUserData: false });
  },

  setLoadingUserData: (loading) => {
    set({ isLoadingUserData: loading });
  },

  clearAuth: () => {
    set({
      isSignedIn: false,
      user: null,
      isLoadingUserData: false
    });
  }
}));

export const selectUser = (state: AuthState) => state.user;
export const selectClearAuth = (state: AuthState) => state.clearAuth;

export const getUserId = (): string | undefined => {
  const user = useAuthStore.getState().user;
  return user?.Id;
};
